import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid ${lightGrey2Color};
  user-select: none;
`;
